import { gql } from '@apollo/client';
import { Article } from '../types';
import performQuery from './contentfulClient';

export const ARTICLE_QUERY = gql`
  query ArticleQuery($slug: String!, $preview: Boolean) {
    ansArticleCollection(where: { slug: $slug }, limit: 1, preview: $preview) {
      items {
        sys {
          id
          publishedAt
        }
        articleTitle
        articleSummary
        articleTip
        slug
        enableDownload
        relatedAsset {
          url
          fileName
        }
        relatedArticlesCollection {
          items {
            sys {
              id
            }
          }
        }
        wistiaVideo
        articleBody {
          json
          links {
            entries {
              hyperlink {
                ... on AnsArticle {
                  sys {
                    id
                  }
                  slug
                  articleTitle
                  subTopicCollection(limit: 1) {
                    items {
                      topicName
                      slug
                    }
                  }
                }
              }
            }
            assets {
              hyperlink {
                sys {
                  id
                }
                title
                url
              }
              block {
                sys {
                  id
                }
                fileName
                contentType
                url
                height
                width
              }
            }
          }
        }
      }
    }
  }
`;

export const useArticleQuery = async (slug: string) => {
  const response = await performQuery(ARTICLE_QUERY, { slug });

  if (response.hasError) {
    return {
      data: null,
      error: true,
      errorMsg: response.error,
    };
  }

  return {
    data: response.res?.data?.ansArticleCollection?.items?.[0] as Article | null,
    error: false,
  };
};
